export default __webpack_public_path__ + "static/media/Heron_ΦΑ.31014e8c.png";